import React, { useEffect, useRef, useState } from 'react';
import { updateSurveyImage } from '../actions';
import { useDispatch } from 'react-redux';
import Snackbar from './Snackbar';

const ImagePicker = ({ imgBlob, kitId, onImageUpdate }) => {
    const dispatch = useDispatch();
    const [image, setImage] = useState(imgBlob);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "info" });
    const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));
    const fileInputRef = useRef(null);
    const MAX_FILE_SIZE_KB = 100;
    const MAX_FILE_SIZE = MAX_FILE_SIZE_KB * 1024;

    useEffect(() => {
        if (imgBlob) {
            setImage(imgBlob.startsWith('data:image') ? imgBlob : `data:image/png;base64,${imgBlob}`);
        }
    }, [imgBlob]);

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.size > MAX_FILE_SIZE) {
            setSnackbar({ open: true, message: `Image size should not exceed ${MAX_FILE_SIZE_KB}KB. Selected image is ${(file.size / 1024).toFixed(2)}KB.`, type: "warning" });
            return;
        }

        const reader = new FileReader();
        reader.onloadend = async () => {
            const base64Image = reader.result;
            setImage(base64Image);
            setLoading(true);

            try {
                const response = await dispatch(updateSurveyImage(kitId, base64Image));
                if (response?.message) {
                    onImageUpdate(base64Image);
                    setSnackbar({ open: true, message: "Image uploaded successfully!", type: "success" });
                } else {
                    setSnackbar({ open: true, message: "Image uploaded, but no confirmation from server.", type: "warning" });
                }
            } catch (error) {
                setSnackbar({ open: true, message: "Failed to upload image. Please try again.", type: "error" });
            } finally {
                setLoading(false);
            }
        };

        reader.readAsDataURL(file);
    };

    const handleImageClick = () => {
        if (loading) return;
        fileInputRef.current.click();
    };

    return (
        <div className="image-picker">
            <Snackbar message={snackbar.message} type={snackbar.type} open={snackbar.open} onClose={closeSnackbar} />
            <div className="profile-pic" onClick={handleImageClick}>
                {loading ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                        <span className="btn-spinner" style={{ width: '24px', height: '24px', borderColor: 'rgba(13,121,120,0.3)', borderTopColor: '#0d7978' }}></span>
                        <span style={{ fontSize: '11px', color: '#718096' }}>Uploading...</span>
                    </div>
                ) : image ? (
                    <img src={image} alt="Pet" />
                ) : (
                    <span>Click to add photo</span>
                )}
            </div>
            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleImageChange}
                style={{ display: 'none' }}
            />
        </div>
    );
};

export default ImagePicker;